export default __webpack_public_path__ + "static/media/colorWhatIfAver.67149802.svg";